import React, { useLayoutEffect, useState } from 'react';
import { base64Kit } from '@meitu/saas-editor-core/es/utils/base64-kit';
import { imageConverter, ownCloudImage } from '@meitu/saas-editor-core/es/utils/file-kit';
import { LayerType } from '@meitu/saas-editor-core/es/version-types';
import IconFont from '@meitu/xdesign-icon-font';
import { handleImageError } from '@/utils/file-kit';
import { useToolbarContext } from '../../hooks/use-toolbar-context';

const ThumbnailController = () => {
    const { pickLayerType, layerType, thumbnail } = useToolbarContext();
    const layersIcons = {
        [LayerType.BRUSH_LAYER]: 'RegionVary',
        [LayerType.TEXT_LAYER]: 'TextFont',
        [LayerType.GROUP_LAYER]: 'FunctionsGroup',
        [LayerType.MEDIA_LAYER]: 'LivePhotoPlay',
        [LayerType.VECTOR_LAYER]: 'Shape',
        [LayerType.TABLE]: 'Tabulation',
        [LayerType.QR_CODE]: 'QrCode',
        [LayerType.WATERMARK]: 'WaterMark',
        [LayerType.MARKUP_LAYER]: 'RegionVary',
        [LayerType.CHART]: 'StackedColumnGraph',
    };

    const [thumbnailUrl, setThumbnailUrl] = useState(base64Kit.getRemoteUrl(thumbnail ?? ''));

    useLayoutEffect(() => {
        base64Kit.getRemoteUrlAsync(thumbnail ?? '').then((url) => {
            setThumbnailUrl(url);
        });
    }, [thumbnail]);

    /**
     * 获取缩略图
     * 1. 如果pickLayerType存在，
     *    i. 如果layerType是图片，展示图片缩略图
     *    ii. 如果layerType是其他类型，展示默认缩略图
     * 2.如果pickLayerType不存在
     *   i. 如果layerType是图片，展示图片缩略图
     *   ii. 如果layerType是其他类型，展示默认缩略图
     */
    const ThumbnailNode = () => {
        const __layerType = pickLayerType || layerType;

        if (__layerType === LayerType.IMAGE_LAYER && thumbnailUrl) {
            return (
                <img
                    src={ownCloudImage(thumbnailUrl) ? `${imageConverter(thumbnailUrl, 120)}` : thumbnailUrl}
                    alt="thumbnail"
                    onError={handleImageError}
                />
            );
        } else {
            return <IconFont name={layersIcons[__layerType]} fontSize={24} />;
        }
    };

    return <div className="c-header-toolbar-thumbnail">{ThumbnailNode()}</div>;
};

export default React.memo(ThumbnailController);
